
export type ConditionalBlockMeta = { conditionalDefinitions?: ConditionalDefinitions };


export enum ConditionResult {
	Valid,
	Invalid,
	Loop
}

export enum ConditionOperators {
	Any = 'any',
	None = 'none',
	NoneOrUnanswered = 'none or unanswered'
}
export type ConditionalDefinition = {
	questionId: string;
	selects: string[];
	conditionId?: string;
	operator?: ConditionOperators;
	subQuestionId?: string;
	record?: { type: string; id: string; name: string }[];
};
export type ConditionalDefinitions = ConditionalDefinition | ConditionalDefinition[];

export type LegacyJsonConditionType = {
	fieldId: string;
	id: string;
	type: string;
}[];
